<template>
  <div
    class="hrm-available flex flex-col items-center md:flex-row md:items-start justify-center mx-auto max-w-7xl w-100 pt-10 md:pt-24"
  >
    <div class="content-block shrink-0 grow-0 pl-6 pr-4 md:pl-8 lg:pr-16 pt-8">
      <div
        class="inner-content mx-auto lg:ml-auto text-center md:text-left pb-4"
      >
        <TypeDisplay
          :variant="$options.Typography.Display.GIGA"
          :weight="$options.Typography.Weights.STRONG"
          tag="p"
          class="mb-6"
        >
          Your HR Manager is available by&nbsp;phone, email, or&nbsp;chat!
        </TypeDisplay>
        <SlideSelector
          :current="currentSlide"
          class="slide-selector hidden md:block"
          @selected="currentSlide = $event"
        />
      </div>
    </div>
    <div
      class="phone-block self-center md:self-end shrink-0 grow-0 pr-6 pl-4 lg:pl-16"
    >
      <SlideShow
        :current="currentSlide"
        class="slide-show mx-auto"
        @change-slide="changeSlide"
      />
    </div>
  </div>
</template>

<script>
import { constants, TypeDisplay } from '@bambeehr/pollen';
import SlideSelector from './Slider/SlideSelector';
import SlideShow from './Slider/SlideShow';

const { Typography } = constants;
export default {
  name: 'HrmAvailable',
  Typography,
  components: {
    SlideShow,
    SlideSelector,
    TypeDisplay,
  },
  data() {
    return {
      currentSlide: 0,
      iconList: [
        {
          icon: 'phone',
          label: 'phone',
        },
        {
          icon: '',
          label: 'email',
        },
        {
          icon: '',
          label: 'chat',
        },
      ],
    };
  },
  methods: {
    changeSlide() {
      if (this.currentSlide < 2) {
        this.currentSlide += 1;
      } else {
        this.currentSlide = 0;
      }
    },
  },
};
</script>

<style scoped>
.inner-content {
  max-width: 410px;
}
</style>
